import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagISSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={props.size ?? 16} viewBox="0 0 16 16">
      <mask id="mask0_13700_23190" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
        <rect x="2" y="2" width="12" height="12" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_13700_23190)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4Z"
          fill="#003897"
        />
        <path
          d="M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H12C12.8284 2.5 13.5 3.17157 13.5 4V12C13.5 12.8284 12.8284 13.5 12 13.5H4C3.17157 13.5 2.5 12.8284 2.5 12V4Z"
          stroke="#3C3C64"
          strokeOpacity="0.1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.875 9.875V14H6.125V9.875H2V6.125H6.125V2H9.875V6.17221H14V9.875H9.875Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.875 6.875V2H9.125V6.875H14V9.125H9.125V14H6.875V9.125H2V6.875H6.875Z"
          fill="#CF142B"
        />
        <rect x="2.5" y="2.5" width="11" height="11" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
